<button
  class="ui-toggle-button"
  [ngClass]="{'isSelected': 'ui-toggle-button--active'}"
  attr.aria-selected="{{ isSelected ? 'true' : 'false' }}"
  (click)="emitClick($event)"
>
  <ng-content></ng-content>
</button>